import { useCallback } from "react";

import { useIntl } from "react-intl";

import agGridMessages from "../../agGridMessages";

const useLocaleTextFunc = () => {
  const intl = useIntl();
  return useCallback(
    (key: string, defaultValue: string) => {
      const message = agGridMessages[key as keyof typeof agGridMessages];
      return message ? intl.formatMessage(message) : defaultValue;
    },
    [intl]
  );
};

export default useLocaleTextFunc;
